import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';
import Link from 'next/link';

import { Typography } from '@common/styles';

interface Props {
  button?: { text: string; landingUrl: string };
  onClickMore?: () => void;
}
export const LayoutWithMoreButton: React.FC<React.PropsWithChildren<Props>> = ({ children, button, onClickMore }) => {
  const displayButton = button && button.text && button.landingUrl;
  return (
    <div>
      {children}
      {displayButton && (
        <Link href={button.landingUrl} passHref legacyBehavior>
          <More className={Typography.BODY_15_SEMIBOLD} onClick={onClickMore}>
            {button.text}
          </More>
        </Link>
      )}
    </div>
  );
};
export const More = styled.a`
  margin: 0 16px 20px 16px;
  display: flex;
  width: calc(100% - 32px);
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  border: 1px solid ${vars.v3Color.gray200};
  color: ${vars.v3Color.gray900};
`;
